module.exports = __webpack_public_path__ + "img/testOutline.ea2c3e74.svg";